import angular from 'angular';
import { StudioService } from './StudioService';
import { StudioSegmentService } from './StudioSegmentService';
import { StudioVersionService } from './StudioVersionService';
export const studioServices = angular
    .module('studioServices', [])
    .service('StudioService', StudioService)
    .service('StudioSegmentService', StudioSegmentService)
    .service('StudioVersionService', StudioVersionService)
    .name;
